import { create } from 'zustand'
import { COMPONENT_DEFAULT_ERRORS, COMPONENT_DEFAULT_FORM } from '@/data'

const SideoverState = create<SideoverStateInterface>((set) => {
    const SideoverInitialState: SideoverStateInterface = {
        Open: false,
        Loading: false,
        Mode: 'create',
        Target: 'component',
        Form: COMPONENT_DEFAULT_FORM,
        Errors: COMPONENT_DEFAULT_ERRORS,
        SetState: (payload: UserInterface) => set((state: SideoverStateInterface) => ({
            ...state,
            ...payload
        }))
    }

    return SideoverInitialState
})

export default SideoverState
